// Generated by purs version 0.15.16
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var state = function (dict) {
    return dict.state;
};
var put = function (dictMonadState) {
    var state1 = state(dictMonadState);
    return function (s) {
        return state1(function (v) {
            return new Data_Tuple.Tuple(Data_Unit.unit, s);
        });
    };
};
var modify_ = function (dictMonadState) {
    var state1 = state(dictMonadState);
    return function (f) {
        return state1(function (s) {
            return new Data_Tuple.Tuple(Data_Unit.unit, f(s));
        });
    };
};
var modify = function (dictMonadState) {
    var state1 = state(dictMonadState);
    return function (f) {
        return state1(function (s) {
            var s$prime = f(s);
            return new Data_Tuple.Tuple(s$prime, s$prime);
        });
    };
};
var gets = function (dictMonadState) {
    var state1 = state(dictMonadState);
    return function (f) {
        return state1(function (s) {
            return new Data_Tuple.Tuple(f(s), s);
        });
    };
};
var get = function (dictMonadState) {
    return state(dictMonadState)(function (s) {
        return new Data_Tuple.Tuple(s, s);
    });
};
export {
    state,
    get,
    gets,
    put,
    modify,
    modify_
};
//# sourceMappingURL=index.js.map
